import { Component, Input, OnInit } from '@angular/core';

import { EntityModel } from 'src/app/model';
import { EntitiesServiceService } from '../../../../services/entities-service.service';

@Component({
  selector: 'app-monotainer-data',
  templateUrl: './monotainer-data.component.html',
  styleUrls: ['./monotainer-data.component.css']
})
export class MonotainerDataComponent implements OnInit {

  @Input() content: EntityModel;

  constructor(
    public service: EntitiesServiceService
  ) { }

  ngOnInit(): void {}

}
